export enum AnimationSteps {
    CARD_TYPING = 0,
    TODO_COL = 1,
    IN_PROG_COL = 2,
    DONE_COL = 3
}

export enum Project {
    TeamRocket = "team-rocket"
}
export enum IssueTypeName {
    TASK = "task",
    STORY = "story",
    BUG = "bug",
    NO_ISSUE = "no-issue"
}
export enum EpicName {
    FEATURES = "features",
    ANALYTICS = "analytics",
    PAYMENTS = "payments",
    ASSETS = "assets",
    STRATEGY = "strategy",
    BUDGET = "budget",
    Q1_CAMPAIGN = "q1 campaign"
}
export enum Assignee {
    ALVIN = "alvin",
    JANE = "jane",
    BLAKE = "blake"
}
export enum Priority {
    HIGH = "high",
    CRITICAL = "critical",
    BLOCKER = "blocker",
    MINOR = "minor"
}
export const stepsLength = Object.keys(AnimationSteps).length / 2;

export const MAX_ISSUE_SUMMARY_LENGTH = 255;

export const SUCCESS_MODAL_DELAY = 3000;

export const ANIMATED_CARD_ID = "animated-card";
